import fetch from './fetch';
import EndPoints from '../data/EndPoints';
import Methods from '../data/Methods';

export default () => {
	return fetch(Methods.GET, EndPoints.DOCUMENTS_USER, null, null, true);
};
